<template>
    <div>
        </van-nav-bar>
        <van-tabs v-model="active" sticky swipeable>
            <van-tab  title="日统计">
                <fin-day-statistics></fin-day-statistics>
            </van-tab>
            <van-tab  title="区间统计">
                <fin-range-statistics></fin-range-statistics>
            </van-tab>
            <van-tab  title="月统计">
                <fin-month-statistics></fin-month-statistics>
            </van-tab>
            <van-tab  title="年统计">
                <fin-year-statistics></fin-year-statistics>
            </van-tab>
            <van-tab  title="聊天统计">
                <talk-statistics></talk-statistics>
            </van-tab>
        </van-tabs>
    </div>

</template>

<script>

    import FinDayStatistics from "./statistics/FinDayStatistics";
    import FinMonthStatistics from "./statistics/FinMonthStatistics";
    import FinRangeStatistics from "./statistics/FinRangeStatistics";
    import TalkStatistics from "./statistics/TalkStatistics";
    import FinYearStatistics from "./statistics/FinYearStatistics";
    export default {
        name: "FinStatistics",
        components: {
            FinMonthStatistics,
            FinDayStatistics,
            FinRangeStatistics,
            TalkStatistics,
            FinYearStatistics
        },
        data(){
            return {
                active:0
            }
        }
    }
</script>

<style scoped>

</style>
